import React, { useEffect, useState } from 'react';
import { TextField, Button, Container, Typography, Box, CssBaseline, Paper } from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import * as localForage from "localforage";

const Login = () => {
  const [email, setEmail] = useState('');
  const { id } = useParams(); // Extract the ID from the URL
    const navigate = useNavigate();
    const [loader, setLoader] = useState(true)
    async function onload() {
        const user = await localForage.getItem('pass'); 
        if(user?._id && user.brandId === id ) navigate('/'+id+'/'+user._id);

        setLoader(false)
    }
    // useEffect(() => onload, [])
    useEffect(() => {
      onload()
    }, [])
    
    
    
    const handleSubmit = async(e) => {
        e.preventDefault();
        try {
            const pass = await axios.get('https://api.walletly.ai/api/v4/pass/widgetpagelogin?brandId='+id+'&email='+email.toLowerCase());
            console.log('pass',pass);
            if(pass?.data?.data?.length>0){
                await localForage.setItem("pass", pass.data.data[0]);
                navigate('/'+id+'/'+pass.data.data[0]._id);
            }
            
        } catch (error) {
            
            alert(`Login Error`);
        }
    
    
    // Add your login logic here (e.g., API call)
  };

  return (
    <div>
{loader?<div className='loaderH'>
            <div class="loader"></div></div>:
    <Container component="main" maxWidth="xs" style={{height: '90vh', alignContent: 'center'}}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={6}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
            width: '100%',
            maxWidth: 400,
          }}
        >
          {/* Logo */}
          {/* <img
            src="https://via.placeholder.com/100" // Replace with your logo URL
            alt="Logo"
            style={{ width: '100px', marginBottom: '20px' }}
          /> */}

<svg width="266" height="99" viewBox="0 0 266 99" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1217_2818)">
<path d="M166.698 9.26481C171.294 14.1712 175.566 18.7309 179.837 23.2905L179.468 23.6665C179.176 23.4402 178.851 23.2503 178.599 22.9875C174.916 19.1069 171.221 15.2336 167.585 11.3055C167.049 10.7251 166.789 9.88907 166.399 9.1699C167.169 8.79023 167.918 8.14042 168.713 8.07836C174.883 7.60013 181.052 7.16206 187.233 6.85541C196.086 6.41368 204.942 6.08147 213.795 5.72736C221.863 5.40611 229.931 5.11406 237.998 4.82931C244.427 4.60297 250.86 4.35838 257.292 4.21236C259.409 4.1649 261.552 4.26712 263.651 4.54456C265.802 4.82566 266.185 5.9245 264.852 7.6768C264.082 8.68802 263.206 9.63718 262.264 10.4878C244.285 26.7878 226.291 43.0732 208.297 59.355C208.034 59.5923 207.728 59.7748 207.238 60.1325C202.2 54.3938 197.199 48.6988 192.165 42.9637C187.675 44.8109 183.239 46.6362 178.8 48.4652C178.661 48.2972 178.523 48.133 178.384 47.965C178.596 47.3882 178.745 46.7749 179.034 46.2346C181.063 42.438 183.206 38.6998 185.141 34.8557C186.287 32.5777 188.007 31.1357 190.34 30.3289C197.732 27.7698 205.121 25.1888 212.532 22.6845C225.115 18.4352 237.714 14.237 250.308 10.0168C250.706 9.88177 251.101 9.74305 251.414 9.27942C249.345 9.72844 247.275 10.1592 245.208 10.6228C225.108 15.146 205.008 19.6691 184.911 24.2104C183.973 24.4222 182.9 24.5938 182.195 25.1633C181.326 25.8642 180.359 26.8827 180.169 27.9049C179.158 33.3406 178.369 38.8166 177.522 44.2852C176.858 48.5637 175.452 50.0386 171.068 50.0605C167.071 50.0824 163.073 49.5165 159.072 49.4289C153.008 49.2975 146.908 48.947 140.881 49.418C129.597 50.2978 120.262 55.4196 112.76 63.8489C107.23 70.0659 101.856 76.4253 96.2741 82.5948C91.8897 87.4392 86.9942 91.7323 81.0985 94.7076C72.4794 99.0627 63.3784 98.9459 54.2153 97.2593C37.7766 94.2366 22.7069 87.3041 7.57138 80.5943C5.46498 79.6597 3.37682 78.6923 1.28867 77.7249C0.843293 77.5204 0.430773 77.243 0 77.0021C0.0730124 76.8414 0.146025 76.6772 0.222688 76.5165C0.722823 76.7319 1.22296 76.94 1.71579 77.1627C14.0366 82.7153 26.31 88.3847 39.1748 92.6121C45.7569 94.7769 52.4484 96.416 59.3627 97.2739C72.034 98.8474 82.8435 95.0799 91.6816 86.0775C97.5482 80.1051 102.926 73.6508 108.515 67.4046C113.224 62.1367 118.043 57.0259 124.377 53.6016C131.218 49.9035 138.588 48.2498 146.255 48.2972C153.049 48.341 159.839 49.0018 166.633 49.3632C168.21 49.4472 169.794 49.5092 171.367 49.4362C174.751 49.2756 176.099 48.1549 176.683 44.8328C177.595 39.6234 178.585 34.4176 179.143 29.168C179.486 25.9591 180.979 24.3784 183.962 23.7067C189.814 22.3924 195.637 20.9358 201.492 19.6289C220.121 15.4672 238.758 11.3457 257.394 7.21682C258.077 7.06349 258.778 6.98318 259.468 6.87001C259.533 7.04524 259.599 7.21682 259.665 7.39205C258.924 7.73155 258.205 8.14042 257.434 8.39962C246.227 12.1671 235.005 15.8943 223.798 19.6654C213.284 23.2065 202.796 26.8389 192.263 30.3325C188.905 31.446 186.496 33.3078 184.995 36.6372C183.389 40.2002 181.315 43.5514 179.683 47.3225C183.615 45.6943 187.547 44.0662 191.993 42.2226C190.394 40.4667 188.971 38.9297 187.583 37.36C187.186 36.9109 186.718 36.3962 186.616 35.8486C186.521 35.3485 186.74 34.6293 187.091 34.2606C187.302 34.0379 188.222 34.1109 188.485 34.3811C190.394 36.3342 192.296 38.3055 193.994 40.4411C194.315 40.8463 193.706 41.9963 193.417 43.2703C197.787 48.2607 202.54 53.6892 207.37 59.2016C212.503 54.58 217.435 50.1554 222.348 45.7126C234.395 34.8228 246.442 23.9293 258.471 13.0213C260.271 11.3895 262.012 9.68829 263.702 7.93964C264.217 7.40665 264.462 6.61447 264.831 5.9391C264.071 5.6434 263.315 5.11041 262.549 5.09216C258.847 5.00454 255.138 4.96439 251.44 5.07025C244.157 5.28199 236.878 5.59594 229.598 5.88069C221.348 6.20195 213.098 6.52685 204.851 6.86271C196.297 7.21317 187.744 7.54172 179.194 7.95424C175.744 8.12217 172.302 8.47628 168.859 8.77563C168.283 8.82674 167.717 9.02752 166.695 9.26481H166.698ZM187.919 34.6147C187.74 34.695 187.562 34.7717 187.386 34.852C187.452 35.2828 187.372 35.8304 187.605 36.1297C188.982 37.8966 190.391 39.6489 191.895 41.3063C192.18 41.6203 192.95 41.4961 193.494 41.5728C193.559 41.372 193.629 41.1676 193.695 40.9668C191.771 38.8494 189.843 36.7321 187.919 34.6147Z" fill="#282828"/>
<path d="M200.017 2.31455L198.699 26.0764C198.662 26.7262 199.294 27.2081 199.911 27L237.757 14.3725C238.118 14.2521 238.37 13.9199 238.385 13.5402L238.932 0.963818C238.954 0.427177 238.516 -0.0181991 237.976 0.00370465L200.9 1.44935C200.426 1.4676 200.042 1.84362 200.017 2.3182V2.31455Z" fill="#282828"/>
<path d="M201.303 2.88028L223.747 13.8467L236.765 2.07715" stroke="#ECF1FD" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M217.953 11.7109L200.832 25.0941" stroke="#ECF1FD" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M226.766 11.5869L232.508 14.0219" stroke="#ECF1FD" stroke-miterlimit="10" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_1217_2818">
<rect width="265.63" height="98.344" fill="white"/>
</clipPath>
</defs>
</svg>


          {/* Login Heading */}
          <Typography component="h1" variant="h5" sx={{ fontWeight: 'bold', textAlign: 'center', mt: '24px' }}>
          Unlock Your Rewards!
          </Typography>
          <Typography component="h5" variant="h9" sx={{ fontWeight: 'normal', textAlign: 'center' }}>
          Log in to track your points, redeem exclusive offers, and stay updated on your rewards.
          </Typography>

          {/* Subtitle */}
          {/* <Typography variant="body2" sx={{ mt: 1, mb: 3, color: 'text.secondary' }}>
            Enter your email to continue
          </Typography> */}

          {/* Email Text Field */}
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
            />

            {/* Submit Button */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 2,
                mb: 2,
                padding: '10px',
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
              }}
            >
              Continue
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>}
    </div>
  );
};

export default Login;